var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-dropdown', { staticClass: "language-selector", attrs: { "trigger": "click" } }, [_c('div', { staticStyle: { "cursor": "pointer" } }, [_c('span', [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('i', { staticClass: "el-icon-arrow-down" })]), _vm._v(" "), _c('el-dropdown-menu', { attrs: { "slot": "dropdown" }, slot: "dropdown" }, _vm._l(_vm.languages, function (item) {
    return _c('el-dropdown-item', { key: item.value }, [_c('div', { on: { "click": function click($event) {
          return _vm.selectLanguage(item.value);
        } } }, [_vm._v(_vm._s(item.label))])]);
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };